exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-a510688a] .el-tabs__content {\n  height: 100% !important;\n}\n.con-left[data-v-a510688a] {\n  background: none !important;\n  flex: 1 1 auto;\n  min-width: 1;\n}\n.con-right[data-v-a510688a] {\n  width: 170px;\n  flex: 0 0 170px;\n}\n.stoptip[data-v-a510688a] {\n  width: 100% !important;\n  height: 100% !important;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-a510688a","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/page/simulate/pddExam.vue
// module id = 1295
// module chunks = 0